import React, {useEffect, useState} from "react";
import {WidgetProps} from "../../widget";
import {TreeSelect} from "antd";
import {icService} from "../../../../../../../services/ic/ic.service";
import {BusinessRegion} from "../../../../../../../models/ic/ic";

const renderTreeNodes = (data: BusinessRegion[]) => {
    return data.map((item) => {
        return (
            <TreeSelect.TreeNode title={item.name} value={item.id} key={item.id}>
                {renderTreeNodes(item.children)}
            </TreeSelect.TreeNode>
        )
    });
}

export const UIInputWidgetBusinessRegion: React.FC<WidgetProps> = ({value, onChange, multiple}) => {

    const [regions, setRegions] = useState<BusinessRegion[]>([]);

    useEffect(() => {
        icService.getAllRegions().then(data => {
            setRegions(data);
        });
    }, []);

    return (
        <TreeSelect
            onChange={onChange as any}
            value={value as any}
            allowClear={true}
            showSearch
        >
            {renderTreeNodes(regions)}
        </TreeSelect>
    )
}